export default __webpack_public_path__ + "static/media/apple-store-navy.3c992942.svg";